<template>
  <div class="h-full overflow-hidden inspect-right">
    <categoryTitle class="mt-10px" title="报警缺陷信息"/>
    <div class="alarm-top-info">
      <div class="alarm-left">
        <span>总数</span>
        <div class="alarm-num">{{alarmTotal}}</div>
      </div>
      <div class="alarm-right">
        <div>
          <span>报警闪烁：</span>
          <span class="mr-4px">{{showAlarmBlink ? '开' : '关'}}</span>
          <el-switch v-model="showAlarmBlink" active-color="#2CE1D9" inactive-color="#0E2E3C"></el-switch>
        </div>
        <i class="iconfont icon-line-list ml-10px" @click="alarmDialogShow=true"></i>
      </div>
    </div>
    <div class="bug-box">
      <bugInfo v-if="alarmList.length" :alarmList="alarmList"></bugInfo>
      <div v-else class="h-[80%] flex justify-center items-center">
        <img src="../../../assets/images/no_data@1x.png" alt="" />
      </div>
    </div>
    <categoryTitle class="mt-10px mb-10px" title="视频监控"/>
    <div class="video-list-box">
      <div class="video-icon video-icon-left" :class="{'video-disable': curVideoIndex === 0}" @click="lastGroupVideo" v-show="videoList.length > 1">
        <i class="el-icon-arrow-left"></i>
      </div>
      <div class="video-icon video-icon-right" :class="{'video-disable': curVideoIndex + 1 >= videoList.length}" @click="nextGroupVideo" v-show="videoList.length > 1">
        <i class="el-icon-arrow-right"></i>
      </div>
      <div class="video-list" ref="videoBoxRef">
        <div class="video-item" v-for="(item, index) in videoList" :key="index">
          <InspectVideo :cameraInfo="item" :videoInfo="videoInfo" :accessToken="accessToken"></InspectVideo>
        </div>
      </div>
    </div>

    <alarmDialog  v-if="alarmDialogShow" @close="alarmDialogShow=false" :inspectPointId="inspectPointId"></alarmDialog>
  </div>
</template>

<script>
import categoryTitle from '@/components/cockpit/CategoryTitle'
import { InspectAlarmRecordApi, InspectPointApi } from '@wiz-api/roam-inspect-management'
import { IOTDeviceProtocolInstanceApi } from '@wiz-api/iot-device-management'
import bugInfo from './bugInfo'
import alarmDialog from './alarmDialog'
// import YSPlayer from '../components/video/YSPlayer/YSPlayer'
import InspectVideo from './inspectVideo'

const iotDeviceProtocolInstanceApi = new IOTDeviceProtocolInstanceApi()
const inspectAlarmRecordApi = new InspectAlarmRecordApi()
const inspectPointApi = new InspectPointApi()

export default {
  name: 'InspectRight',
  components: {
    categoryTitle,
    bugInfo,
    alarmDialog,
    // YSPlayer,
    InspectVideo
  },
  props: {
    transferProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
  },
  data() {
    return {
      showAlarmBlink: true,
      videoData: [],
      videoList: [],
      curVideoIndex: 0,
      alarmList: [],
      alarmTotal: 0,
      alarmDialogShow: false,
      inspectPointId: '',
      pIid: '',
      videoInfo: {}, // 视频登录账号密码
      accessToken: '',
      imosSdkInit: false,
      scrollTimer: null,
      scrollDirection: 'left',
    }
  },
  watch: {
    transferProps: {
      handler(data) {
        if (data?.piId) {
          // console.log(data, 'InspectRight transferProps data')
          this.getConfig(data.piId)
        }
        if (data?.inspectPointId) {
          if (this.inspectPointId === data.inspectPointId) return
          this.inspectPointId = data.inspectPointId
          this.getVideoList(data.cameras || [])
          this.getAlarmList(data.inspectPointId)
        }
      },
      deep: true,
      immediate: true,
    },
    videoList() {
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer)
        this.scrollTimer = null
      }
      if (this.videoList.length > 1) {
        this.scrollTimer = setInterval(() => {
          if (this.scrollDirection === 'left') {
            this.nextGroupVideo()
          } else {
            this.lastGroupVideo()
          }
        }, 10 * 1000)
      }
    },
    showAlarmBlink(val) {
      this.sendInfoToRightDialog('detail', {
        alarmSet: true,
        showAlarmBlink: val
      })
    },
    imosSdkInit(val) {
      if (val && this.videoData.length) {
        this.getVideoList(this.videoData)
      }
    }
  },
  methods: {
    // 传递信息给一级弹框
    sendInfoToRightDialog(type, data) {
      this.$emit('transferEvent', {
        toCom: { code: 'InspectRoute', origin: 'InspectRight', name: '巡检路线' },
        type,
        props: data
      })
    },
    // 报警统计
    async getAlarmList(pointId) {
      const [err, res] = await inspectAlarmRecordApi.getList({
        inspectPointId: pointId,
        SkipCount: 0,
        MaxResultCount: 20
      })
      if (!err) {
        this.alarmList = res.items
        this.alarmTotal = res.totalCount
      }
    },
    /* eslint-disable no-await-in-loop */
    async getVideoList(cameras) {
      this.videoData = cameras
      if (this.imosSdkInit) {
        if (this.scrollTimer) {
          clearInterval(this.scrollTimer)
          this.scrollTimer = null
        }
        this.curVideoIndex = 0
        this.scrollDirection = 'left'
        if (this.$refs.videoBoxRef) {
          this.$refs.videoBoxRef.style.transform = 'translateX(0)'
        }
        for (let i = 0; i < cameras.length; i += 1) {
          const presetList = await this.getPreset(cameras[i])
          cameras[i].presetList = presetList.filter((item) => { return item.PresetDesc !== '初始位' })
          if (presetList.length) {
            cameras[i].initPresetInfo = await this.setInitPreset(cameras[i])
          }
          console.log(cameras[i].presetList, 'presetList')
        }
        this.videoList = cameras
      }
    },
    // getPreset1(videoItem) {
    //   return new Promise((resolve) => {
    //     setTimeout(() => {
    //       resolve([
    //         { PresetValue: 1 }, { PresetValue: 2 }, { PresetValue: 3 }
    //       ])
    //     }, 1000)
    //   })
    // },
    // setInitPreset1() {
    //   return new Promise((resolve) => {
    //     setTimeout(() => {
    //       resolve({
    //         PresetValue: 254,
    //         PresetDesc: '初始位'
    //       })
    //     }, 1000)
    //   })
    // },
    // 新增初始预置点位
    setInitPreset(videoItem) {
      return new Promise((resolve, reject) => {
        const url = `http://${this.videoInfo.ipAddress}:${this.videoInfo.port}/VIID/ptz/preset/set/${videoItem.cameraCode}`
        const requestOption = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json; charset=utf8',
            Authorization: this.accessToken,
          },
          body: JSON.stringify({
            PresetValue: 254,
            PresetDesc: '初始位',
          })
        }
        fetch(url, requestOption)
          .then((response) => {
            if (response.status === 200) {
              return response.json()
            }
            throw new Error('网络请求失败')
          })
          .then((res) => {
            if (res.ErrCode === 0) {
              resolve({
                PresetValue: 254,
                PresetDesc: '初始位'
              })
            } else {
              resolve({})
              throw new Error(res.ErrMsg)
            }
          })
          .catch((error) => {
            resolve({})
            throw new Error(error)
          })
      })
    },
    // 获取预置位
    getPreset(videoItem) {
      return new Promise((resolve, reject) => {
        const url = `http://${this.videoInfo.ipAddress}:${this.videoInfo.port}/VIID/ptz/query/preset?code=${videoItem.cameraCode}`
        const requestOption = {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json; charset=utf8',
            Authorization: this.accessToken,
          },
        }
        fetch(url, requestOption)
          .then((response) => {
            if (response.status === 200) {
              return response.json()
            }
            throw new Error('网络请求失败')
          })
          .then((res) => {
            if (res.ErrCode === 0 && res.Result) {
              const { InfoList = [] } = res.Result
              resolve(InfoList)
            } else {
              resolve([])
              throw new Error(res.ErrMsg)
            }
          })
          .catch((error) => {
            resolve([])
            throw new Error(error)
          })
      })
    },
    async getConfig(pIid) {
      const [err, res] = await iotDeviceProtocolInstanceApi.get(pIid)
      if (!err) {
        const parsedInfo = JSON.parse(res.jsonContent)
        this.videoInfo = {
          ipAddress: parsedInfo.IP,
          username: parsedInfo.UserName,
          password: parsedInfo.PassWord,
          port: parsedInfo.Port
        }
        this.login()
      } else {
        this.videoInfo = {
          ipAddress: '',
          username: '',
          password: '',
          port: ''
        }
      }
    },
    async login() {
      const apiUrl = `http://${this.videoInfo.ipAddress}:${this.videoInfo.port}/VIID/login/v2`
      const requestOption = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=utf8',
        },
      }
      fetch(apiUrl, requestOption)
        .then((response) => {
          if (response.status === 200) {
            return response.json()
          }
          throw new Error('网络请求失败')
        })
        .then((res) => {
          // console.log('第一次调登录接口的响应结果', res)
          const accessCode = res.AccessCode
          const md2 = forge.md.md5.create() // md5
          const base64Username = window.btoa(this.videoInfo.username)
          const loginSignatureTemp = base64Username + accessCode + this.videoInfo.password
          md2.update(loginSignatureTemp) // md5
          const loginSignature = md2.digest().toHex() // md5
          const data = {
            UserName: this.videoInfo.username,
            AccessCode: accessCode,
            LoginSignature: loginSignature,
          }
          const requestOpion2 = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json; charset=utf8',
            },
            body: JSON.stringify(data),
          }
          fetch(apiUrl, requestOpion2)
            .then((response) => {
              // console.log('第二次调登录接口的请求响应状态信息', response)
              if (response.status === 200) {
                return response.json()
              }
              throw new Error('网络请求失败')
            })
            .then((r) => {
              const loginResult = r.ErrCode
              switch (
                loginResult // 判断返回值：12351是‘用户不存在’；50004是‘密码错误，登录失败’
              ) {
                case 50004:
                  // console.log('密码错误')
                  break
                case 12351:
                  // console.log('用户不存在')
                  break
                case undefined:
                  // console.log('登录成功AccessToken', r.AccessToken)
                  this.accessToken = r.AccessToken
                  this.initImosSdk()
                  break
                default:
              }
            })
            .catch((e) => {
              // console.log('服务器连接异常')
            })
        })
        .catch((error) => {
          // console.log('服务器连接异常123', error)
        })
    },
    initImosSdk() {
      const ishttps = document.location.protocol === 'https:'
      if (ishttps) {
        imosSdk.setLinkPort('7077')
      }
      imosSdk
        .init(this.videoInfo.ipAddress, this.accessToken, 10, '/unv/imosSdk.html')
        .then(() => {
          // console.log('imosSdk init 成功')
          // 设置后续事件回调
          imosSdk.registerLiveMsg((result) => {
            // console.log(result, '事件回调')
          })
          this.imosSdkInit = true
        })
        .catch((err) => {
          // console.log(err, '调用失败')
        })
    },
    lastGroupVideo() {
      if (this.curVideoIndex === 0) return
      this.curVideoIndex = this.curVideoIndex - 1
      const offset = -this.curVideoIndex * 100
      if (this.$refs.videoBoxRef) {
        this.$refs.videoBoxRef.style.transform = `translateX(${offset}%)`
      }
      if (this.curVideoIndex === 0) {
        this.scrollDirection = 'left'
      }
    },
    nextGroupVideo() {
      if (this.curVideoIndex + 1 >= this.videoList.length) return
      this.curVideoIndex = this.curVideoIndex + 1
      const offset = -this.curVideoIndex * 100
      if (this.$refs.videoBoxRef) {
        this.$refs.videoBoxRef.style.transform = `translateX(${offset}%)`
      }
      if (this.curVideoIndex + 1 >= this.videoList.length) {
        this.scrollDirection = 'right'
      }
    }
  },
  beforeDestroy() {
    if (this.scrollTimer) {
      clearInterval(this.scrollTimer)
      this.scrollTimer = null
    }
    this.inspectPointId = ''
    this.sendInfoToRightDialog('detail', {
      returnBack: true
    })
  },
}
</script>

<style lang="scss" scoped>
.inspect-right {
  display: flex;
  flex-direction: column;

  .alarm-top-info {
    display: flex;
    justify-content: space-between;
    margin: 10px 0;
    font-size: 14px;
    color: #fff;

    .alarm-left {
      display: flex;
      align-items: center;

      .alarm-num {
        margin-left: 15px;
        min-width: 94px;
        font-size: 18px;
        text-align: center;
        color: #FF8900;
        background: #063F4B;
        font-weight: bold;
      }
    }

    .alarm-right {
      display: flex;
      align-items: center;
    }
  }

  .bug-box {
    flex: 1;
    overflow: auto;
  }

  .carousel-wrapper {
    margin-bottom: 10px;
    height: 207px;

    ::v-deep.el-carousel__container {
      height: 100% !important;
    }

    ::v-deep .el-carousel__button {
      width: 3px;
      height: 3px;
      background: white;
      border-radius: 100%;
    }

    ::v-deep .is-active {
      .el-carousel__button {
        width: 10px;
        height: 3px;
        background: #44F1FF;
        border-radius: 3px;
      }
    }

    .video-item {
      height: 100%;
    }
  }

  .video-list-box {
    position: relative;
    overflow: hidden;
    margin-bottom: 10px;
    height: 207px;

    .video-icon {
      position: absolute;
      top: 50%;
      z-index: 2;
      width: 36px;
      height: 36px;
      font-size: 12px;
      text-align: center;
      color: rgb(182, 182, 182);
      background: #01504db3;
      border-radius: 50%;
      box-shadow: inset 0 4px 9px 0 #548c81c7;
      transition: all 0.3s;
      transform: translateY(-50%);
      line-height: 36px;
      cursor: pointer;
    }

    .video-disable {
      cursor: not-allowed;
    }

    .video-icon-left {
      left: -36px;
    }

    .video-icon-right {
      right: -36px;
    }

    &:hover {
      .video-icon-left {
        left: 8px;
      }

      .video-icon-right {
        right: 8px;
      }
    }
  }

  .video-list {
    display: flex;
    width: 100%;
    height: 100%;
    transition: all 0.3s;

    .video-item {
      flex-shrink: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
